import type { RefObject } from 'react';
import type { TFunction } from 'react-i18next';
import type { GuardBusy, GuardCopy } from 'ts-components/PiChat/PiChatPanel';

interface SurfaceClaim {
  id: string;
  onEvicted: () => void;
  guard: GuardBusy;
}

const run: GuardBusy = (action) => action();

let current: SurfaceClaim | null = null;

/** For a chat being replaced by another AI surface opening over it. */
export const leaveChatCopy = (t: TFunction): GuardCopy => ({
  heading: t('Leave this chat?'),
  body: t('The AI is still working. Opening another chat stops it.'),
  confirm: t('Leave'),
});

/** A surface's claim guard: asks its mounted panel with the leave copy; with no panel mounted nothing is busy, so the action runs. */
export const panelSurfaceGuard = (
  panel: RefObject<GuardBusy>,
  t: TFunction
): GuardBusy => {
  const copy = leaveChatCopy(t);
  return (action) => {
    if (panel.current) panel.current(action, copy);
    else action();
  };
};

export const claimKiCodeSurface = (
  id: string,
  onEvicted: () => void,
  guard: GuardBusy = run
): (() => void) => {
  const previous = current;
  const next = { id, onEvicted, guard };
  current = next;
  if (previous && previous.id !== id) previous.onEvicted();
  return () => {
    if (current === next) current = null;
  };
};

export const guardKiCodeSurface: GuardBusy = (action) =>
  (current?.guard ?? run)(action);
